<template>
  <div class="before-find-work">
    <button @click.prevent="$vModal.close('auth-before-find-work')"
            class="before-find-work__close   base-btn">
      <BaseSvg name="ico-close"/>
    </button>
    <div class="before-find-work__title">{{ $tHome('Registration on site by one click') }}</div>
    <router-link-modified :to="{name: 'auth'}"
                          class="before-find-work__btn  base-btn  base-btn--green">
      <span>{{ $tHome('Register') }}</span>
      <BaseSvg name="ico-arrow-light"/>
    </router-link-modified>
    <router-link-modified :to="{name: 'auth'}"
                          class="before-find-work__link  inline-link">
      <span>{{ $tHome('Already registered? Log in') }}</span>
      <BaseSvg name="ico-arrow-light" style="margin-left: 0.3rem"/>
    </router-link-modified>

    <div class="before-find-work__soc-bot-wrap">
      <div class="before-find-work__soc-bot-text  text">
        <p>{{ $tHome('We also launched a chatbot in Viber, Telegram and Facebook Messenger:') }}</p>
      </div>
      <div class="before-find-work__soc-bot-title">{{ $tHome('bot_name') }}</div>
      <div class="before-find-work__soc-bot-list">
        <div class="before-find-work__soc-bot-item  _viber  _disabled">
          <BaseSvg name="ico-viber"/>
        </div>
        <div class="before-find-work__soc-bot-item  _telegram  _disabled">
          <BaseSvg name="ico-telegram"/>
        </div>
        <div class="before-find-work__soc-bot-item  _messenger  _disabled">
          <BaseSvg name="ico-messenger"/>
        </div>
      </div>
      <div class="before-find-work__soc-bot-note">
        {{ $tHome('Receive new offers in a messenger convenient for you') }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalAuthBeforeFindWork',
    data() {
      return {}
    },
    beforeDestroy() {
      if (this.isRouteNameMixin('home')) {
        this.$router.push({name: 'vacancies'})
      }
    }
  }
</script>

<style lang="less">

</style>
